import React from "react";
import styles from "./Navbar.module.css";
import Logo from "../../assets/images/louisville-logo.png";

const Navbar: React.FC = () => {
  return (
    <nav className={styles.navbar}>
      <img src={Logo} alt="Department Logo" className={styles.logo} />
    </nav>
  );
};

export default Navbar;
